@for (option of options; track option.display_name) {
    <div class="split-button-item" (click)="handleCallback(option)">
        @if (hasIconClassSet(option)) {
            <i class="split-button-item__icon" [ngClass]="option.icon_class"></i>
        }
        <span class="split-button-item__text">{{option.display_name}}</span>
    </div>
}